import { BehaviorSubject } from 'rxjs';
import { DwMenuExecuteService } from './menu-execute.service';
var DwRecursiveMenuService = /** @class */ (function () {
    function DwRecursiveMenuService(menuExecuteService) {
        this.menuExecuteService = menuExecuteService;
        this._routeSelectMenu = false; // 路由影響選單選中節點(TabMenu是否和Menu連動),預設false
        this._menuList = [];
        this._$menuList = new BehaviorSubject(this._menuList);
    }
    Object.defineProperty(DwRecursiveMenuService.prototype, "selectable", {
        get: function () {
            return this._selectable;
        },
        set: function (selectable) {
            this._selectable = selectable || false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwRecursiveMenuService.prototype, "routeSelectMenu", {
        get: function () {
            return this._routeSelectMenu;
        },
        set: function (routeSelectMenu) {
            this._routeSelectMenu = routeSelectMenu || false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwRecursiveMenuService.prototype, "menuList", {
        get: function () {
            return this._menuList;
        },
        set: function (menuList) {
            this._menuList = menuList;
            this._$menuList.next(this._menuList);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwRecursiveMenuService.prototype, "$menuList", {
        get: function () {
            return this._$menuList.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    // 點選Menu
    DwRecursiveMenuService.prototype.onClickItem = function (menuItem) {
        if (!menuItem.disabled) {
            // if (this._usingTab) {
            //   this.onSelect(menuItem.id); // 若需要儲存Menu才做，避免消耗效能
            // }
            this.menuExecuteService.menuClick(menuItem);
        }
    };
    /**
     * 選中節點
     * 畫面[dwSelected]屬性無法雙向綁定，需要自行改變數中的屬性
     */
    DwRecursiveMenuService.prototype.onSelect = function (menuId) {
        if (this.selectable && this._routeSelectMenu) {
            // this.recursiveMenuStorageService.selectMenuId = '';
            var ret = this.onSelectChange(this._menuList, menuId, null);
            if (ret.isChange) {
                this.menuList = ret.menuList;
            }
        }
    };
    /**
     * 依運行中的作業編號取得Menu節點
     */
    DwRecursiveMenuService.prototype.getMenuItemByProgramId = function (menuDataSource, programId) {
        var matchMenu;
        var len = menuDataSource.length;
        for (var i = 0; i < len; i++) {
            var menuItem = JSON.parse(JSON.stringify(menuDataSource[i]));
            if (menuItem.programId === programId) {
                matchMenu = menuItem;
                break;
            }
            if (menuItem.child.length > 0) {
                matchMenu = this.getMenuItemByProgramId(menuItem.child, programId);
                if (matchMenu) {
                    break;
                }
            }
        }
        return matchMenu;
    };
    DwRecursiveMenuService.prototype.onSelectChange = function (menuDataSource, menuId, programId) {
        var menuList = [];
        var len = menuDataSource.length;
        var ret = {
            menuList: menuList,
            isFind: false,
            isChange: false // 是否改變Menu的屬性，避免沒改值也觸發廣播事件
        };
        for (var i = 0; i < len; i++) {
            var menuItem = JSON.parse(JSON.stringify(menuDataSource[i]));
            // Menu用menuId找，Tab Menu用programId找
            var selected = false;
            if (menuId) {
                if (menuItem.id === menuId) {
                    selected = true;
                }
            }
            else {
                if (menuItem.programId === programId) {
                    selected = true;
                }
            }
            if (menuItem.selected !== selected) {
                menuItem.selected = selected;
                ret.isChange = true;
            }
            if (menuItem.selected) {
                ret.isFind = true;
                // this.recursiveMenuStorageService.selectMenuId = menuItem.id;
            }
            if (menuItem.child.length > 0) {
                var childRet = this.onSelectChange(menuItem.child, menuId, programId);
                menuItem.child = childRet.menuList;
                // 子階層如果有找到，父以上的目錄都要打開
                if (childRet.isFind) {
                    menuItem.open = true;
                    ret.isFind = true;
                }
                if (childRet.isChange) {
                    ret.isChange = childRet.isChange;
                }
            }
            menuList.push(menuItem);
        }
        ret.menuList = menuList;
        return ret;
    };
    return DwRecursiveMenuService;
}());
export { DwRecursiveMenuService };
